/**
 * External dependencies
 */
import { KeyboardAvoidingView as AndroidKeyboardAvoidingView } from 'react-native';

export const KeyboardAvoidingView = AndroidKeyboardAvoidingView;

export default KeyboardAvoidingView;
